<div class="my-3 my-md-5">
    <div class="container-fluid px-4">
        <div class="container-fluid row">
            <div class="col-md-12"><h3>Patient Mobile Login Report</h3></div>
        </div>
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                <mat-panel-title>
                    <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row filter_row">
                    <div class="col-sm-3 mt-2">
                        <input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadData(0,perpage)" placeholder="Search" />
                    </div>
                    <div class="col-sm-3 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon class="cross_icon" (click)="clearDate()">clear</mat-icon>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadData(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportLeadData()"><i class="fa fa-file-excel"></i> Export List</button>
                 </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Glamyo Patient ID</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Last Login Date/Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let lead of patientData;let index = index;">
                            <td >{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{lead.glamyo_patient_id}}</td>
                            <td>{{lead.name}}</td>
                            <td>{{lead.mobile}}</td>
                            <td>{{lead.login_time}}</td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !patientData.length">
                            <td colspan="5" class="text-center"><i class="far fa-frown"></i> No data found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>